<div class="p-2 page-height overflow-auto bg-panel">
  <div class="page-container">
    <mat-card class="rounded-md">
      <mat-card-content>
        <div class="d-flex align-items-center gap-2 mb-1">
          <button mat-icon-button class="mon-text-primary flex-shrink-0" (click)="backToSettings()"
                  matTooltip="Back to settings" aria-label="Back to settings" data-test="settings-receipts-back-button">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <h5 class="mb-0">Receipt Configuration</h5>
        </div>
        <p class="text-muted small mb-3">
          Customise merchant and customer receipt settings, including email
          subject, recipient phone number, and receipt email addresses.
        </p>
        <div class="hr-light mb-4"></div>

        @if (configLoading) {
          <div class="d-flex align-items-center justify-content-center">
            <mat-progress-spinner
              [diameter]="60"
              [strokeWidth]="5"
              [color]="'primary'"
              class="spinner"
              mode="indeterminate"
            ></mat-progress-spinner>
          </div>
        } @else {
          <div>
            @if (changeLoading) {
              <div class="change-loading-overlay">
                <mat-progress-spinner
                  [diameter]="60"
                  [strokeWidth]="5"
                  [color]="'primary'"
                  class="spinner"
                  mode="indeterminate"
                ></mat-progress-spinner>
              </div>
            }
            <!-- NEW CONFIG -->
            @if (!receiptConfiguration) {
              <div>
                <!-- Tooltip sits on the wrapper as disabled buttons don't receive pointer events -->
                <span
                  matTooltip="You don't have the required permission to create receipts."
                  [matTooltipDisabled]="receiptManagePermission"
                  class="d-inline-block"
                >
                  <button
                    (click)="createNewConfiguration()"
                    [disabled]="!receiptManagePermission"
                    mat-flat-button
                    class="d-block bg-white-always mon-border-primary border mon-text-primary flex-shrink-0"
                    data-test="settings-receipt-configuration-create-new-configuration-button"
                  >
                    Create New Configuration
                  </button>
                </span>
              </div>
            } @else {
              <!-- MODIFY CONFIG -->
              <div>
                <h6 class="fw-semibold mb-2">Outbound Settings</h6>
                <div class="bg-light border border-1 rounded p-3">
                  <mat-form-field class="w-100">
                    <mat-label>Send To</mat-label>
                    <mat-select [(ngModel)]="receiptConfiguration.enabledFor">
                      <mat-option [value]="0">Customers</mat-option>
                      <mat-option [value]="1">Merchants</mat-option>
                      <mat-option [value]="2">Both</mat-option>
                      <mat-option [value]="3">Disabled</mat-option>
                    </mat-select>
                  </mat-form-field>
                  @if (
                    receiptConfiguration.enabledFor === 0 ||
                    receiptConfiguration.enabledFor === 2
                  ) {
                    <mat-form-field class="w-100">
                      <mat-label>Customer Send Type</mat-label>
                      <input matInput value="E-Mail" disabled />
                    </mat-form-field>
                  }
                  @if (
                    receiptConfiguration.enabledFor === 1 ||
                    receiptConfiguration.enabledFor === 2
                  ) {
                    <mat-form-field class="w-100">
                      <mat-label>Merchant Send Type</mat-label>
                      <input matInput value="E-Mail" disabled />
                    </mat-form-field>
                  }
                  @if (receiptConfiguration.enabledFor !== 3) {
                    <mat-form-field class="w-100">
                      <mat-label>Trading Name</mat-label>
                      <input
                        matInput
                        [(ngModel)]="receiptConfiguration.tradingName"
                      />
                    </mat-form-field>
                  }
                </div>
                <!-- EMAIL -->
                @if (
                  receiptConfiguration &&
                  receiptConfiguration.emailConfiguration
                ) {
                  <div class="mt-4">
                    @if (
                      (receiptConfiguration.enabledFor === 1 ||
                        receiptConfiguration.enabledFor === 2) &&
                      (receiptConfiguration.merchantDestination === 0 ||
                        receiptConfiguration.merchantDestination === 2)
                    ) {
                      <div>
                        <h6 class="fw-semibold mb-2 mt-3">
                          Merchant Email Settings
                        </h6>
                        <div class="bg-light border border-1 rounded p-3">
                          <div>
                            @for (
                              email of emails;
                              track trackEmail(index, email);
                              let index = $index
                            ) {
                              <div
                                class="d-flex align-items-start justify-content-start"
                              >
                                <mat-form-field class="w-100">
                                  <mat-label
                                    >Merchant Email Address ({{
                                      index + 1
                                    }})</mat-label
                                  >
                                  <input
                                    matInput
                                    [ngModel]="
                                      receiptConfiguration.emailConfiguration
                                        .merchantEmailAddresses[index]
                                    "
                                    (ngModelChange)="UpdateEmail(index, $event)"
                                  />
                                </mat-form-field>
                                @if (receiptManagePermission) {
                                  <button
                                    (click)="RemoveEmail(index)"
                                    class="delete-email-button rounded-2 ms-2 d-block mon-bg-danger mon-border-danger border mon-text-danger flex-shrink-0"
                                    data-test="settings-receipt-configuration-remove-email-button"
                                  >
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                }
                              </div>
                            }
                            @if (receiptManagePermission) {
                              <button
                                (click)="AddEmail()"
                                mat-flat-button
                                class="d-block mon-bg-success mon-border-success border mon-text-success flex-shrink-0"
                                data-test="settings-receipt-configuration-add-email-button"
                              >
                                Add Email
                              </button>
                            }
                          </div>
                          <mat-form-field class="w-100 mt-3">
                            <mat-label>Email Subject</mat-label>
                            <input
                              matInput
                              required
                              [(ngModel)]="
                                receiptConfiguration.emailConfiguration
                                  .merchantEmailSubject
                              "
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    }
                    @if (
                      (receiptConfiguration.enabledFor === 0 ||
                        receiptConfiguration.enabledFor === 2) &&
                      (receiptConfiguration.customerDestination === 0 ||
                        receiptConfiguration.customerDestination === 2)
                    ) {
                      <div>
                        <h6 class="fw-semibold mb-2 mt-3">
                          Customer Email Settings
                        </h6>
                        <div class="bg-light border border-1 rounded p-3">
                          <mat-form-field class="w-100">
                            <mat-label>Email Subject</mat-label>
                            <input
                              matInput
                              required
                              [(ngModel)]="
                                receiptConfiguration.emailConfiguration
                                  .customerEmailSubject
                              "
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- SMS-->
                @if (
                  smsEnabled &&
                  receiptConfiguration &&
                  receiptConfiguration.smsConfiguration
                ) {
                  <div class="mt-4">
                    @if (
                      (receiptConfiguration.enabledFor === 1 ||
                        receiptConfiguration.enabledFor === 2) &&
                      (receiptConfiguration.merchantDestination === 1 ||
                        receiptConfiguration.merchantDestination === 2)
                    ) {
                      <div>
                        <h6 class="fw-semibold mb-2 mt-3">
                          Merchant SMS Settings
                        </h6>
                        <div class="bg-light border border-1 rounded p-3">
                          <mat-form-field class="w-100">
                            <mat-label>Merchant Phone Number</mat-label>
                            <input
                              matInput
                              [(ngModel)]="
                                receiptConfiguration.smsConfiguration
                                  .merchantPhoneNumber
                              "
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    }
                    @if (
                      (receiptConfiguration.enabledFor === 0 ||
                        receiptConfiguration.enabledFor === 2) &&
                      (receiptConfiguration.customerDestination === 1 ||
                        receiptConfiguration.customerDestination === 2)
                    ) {
                      <div>
                        <h6 class="fw-semibold mb-2 mt-3">
                          Customer SMS Settings
                        </h6>
                        <div class="bg-light border border-1 rounded p-3">
                          <p class="text-muted mb-0">
                            No configuration available.
                          </p>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (errors.length > 0) {
                  <div class="mt-3 px-0">
                    @for (error of errors; track error) {
                      <p class="mon-text-danger small mb-1">
                        {{ error.error }}
                      </p>
                    }
                  </div>
                }
                <div class="d-flex justify-content-end mt-4 gap-2">
                  @if (
                    !configLoading &&
                    receiptConfiguration !== null &&
                    receiptManagePermission
                  ) {
                    <button
                      (click)="updateConfiguration()"
                      [disabled]="!hasChanged()"
                      mat-flat-button
                      class="d-block bg-white-always mon-border-success border mon-text-success flex-shrink-0"
                      data-test="settings-receipt-configuration-update-configuration-button"
                    >
                      Save
                    </button>
                  }
                  @if (!configLoading && receiptManagePermission) {
                    <button
                      (click)="deleteConfiguration()"
                      mat-flat-button
                      class="d-block mon-bg-danger mon-border-danger border mon-text-danger flex-shrink-0"
                      data-test="settings-receipt-configuration-delete-configuration-button"
                    >
                      Delete Configuration
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</div>
